export const useLogging = () => {
  const stateTracker = {
    trackState: () => null
  };
  return {
    stateTracker
  };
};